<template>
  <div class="searching">
<!--    <van-nav-bar title="公示公告" left-arrow @click-left="onClickLeft">-->
<!--      <template #left>-->
<!--        <van-icon name="arrow-left" size="18" color="black"/>-->
<!--      </template>-->
<!--    </van-nav-bar>-->

    <div class="search-nav">
    <van-search
        shape="round"
        placeholder="请输入搜索词"
        v-model="keyword"
        @keydown.enter="goSearch(keyword)"
        @focus="searchFocus"
    />
  </div>
    <div class="search-model">
      <div class="search-page" v-show="historyShow">
      <div class="history">
        <span class="search-title">搜索历史</span>

        <img class="ico-trash" v-show="historyList.length>0" :src="require('@/assets/img/common/icon-trash.png')" alt=""
             @click="historyDelete">
      </div>
      <div class="history-list">

        <van-button v-for="(item,index) in historyList" :key="index" round type="info" color="#F1F3F6"
                    @click="clickHistoryItem(item)">{{ item }}
        </van-button>
      </div>
      <div class="find">
        <span class="search-title">搜索发现</span>
        <img class="ico-eyes" v-show="findList.length>0" :src="require('@/assets/img/common/icon-eyes.png')" alt=""
             @click="findEyes">
      </div>
      <div class="find-list">
        <van-button v-for="(item,index) in findList" :key="index" round type="info" color="#F1F3F6"
                    @click="clickFindItem(item.content)">{{ item.content }}
        </van-button>
      </div>
      </div>

      <van-pull-refresh
                        v-show="listShow"
                        v-model="refreshConfig.refreshing"
                        style="min-height: 100vh"
                        @refresh="onRefresh">
        <van-list
            v-model="refreshConfig.loading"
            :finished="refreshConfig.finished"
            :finished-text="refreshConfig.finishedText"
            :error.sync="refreshConfig.error"
            :error-text="refreshConfig.errorText"
            @load="onLoad">
          <div v-for="(item,index) in list" :key="index" @click="onClickListItem(item)" v-show="item.BT">
            <div class="list-item">
              <span class="content">{{ item.BT ? item.BT : '' }}</span>

              <div class="van-icon-container">
                <van-icon class="van-icon" name="arrow" color="#999"/>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>

      <div class="no-data-page"  v-if="noResultShow">
        <no-data ></no-data>
      </div>

    </div>


  </div>
</template>

<script>
import NoData from "../../components/NoData";
import listMixins from "@/mixins/comListMixins";
import api from '@/utils/api/announce'

export default {
  name: "search",
  mixins: [listMixins],
  components: {
    NoData
  },
  props:{},
  data() {
    return {
      keyword: "",
      historyList: JSON.parse(localStorage.getItem("historyList")) || [],
      findList: [],
      list: [],
      historyShow: false,
      listShow: true,
      noResultShow:false,
      loading: false,//加载
      finished: false,//是否已经加载完成
      refreshing: false,//下拉刷新
    }
  },
  watch: {
    keyword() {
      this.searchFocus()
    }
  },
  computed: {},
  methods: {
    onClickLeft() {
      if (this.keyword) {
        this.keyword = ''
      } else {
        this.$router.go(-1);
      }
    },
    clickHistoryItem(index) {
      this.keyword = index
    },
    clickFindItem(index) {
      this.keyword = index
    },
    onClickListItem(item) {
      // if(item.BT){
        this.$router.push({
          name: 'announcementDetails',
          query: {rid: item.RID}
        })
      // }
      
    },
    //搜索栏聚焦状态
    searchFocus() {
      if (this.keyword) {
        this.listShow = false
        this.historyShow = true
      } else {
        this.listShow = true
        this.historyShow = false
        this.onRefresh()
      }
    },
    //回车搜索
    goSearch(info) {
      if (this.historyList.indexOf(this.keyword) <= -1){
        this.historyList.push(info)
      }
      if (window.localStorage != null) {
        localStorage.setItem("historyList", JSON.stringify(this.historyList))
      }
      if (this.keyword){
        this.list = []
      }
      this.historyShow = false
      this.onRefresh()

    },
    historyDelete() {
      this.historyList = []
      localStorage.removeItem("historyList")
    },
    findEyes() {

    },

    //获取列表
    loadData(data){
      let params = {
        BT: this.keyword,
        dateStart: "",
        dateEnd: "",
        page: data.page,
        rows: data.rows,
      }
      return api.getAnnouncementList(params).then(res=>{
        // console.log('--res', res.rowsList)
        if (data.page === 1) {
          this.list = res.rowsList
        } else {
          this.list.push(...res.rowsList)
        }
        this.finished = this.list.length >= res.total
        this.listShow = this.list.length
        this.noResultShow = !this.list.length
        return Promise.resolve(res)
      })
    },
  },

}
</script>

<style lang="scss" scoped>
.searching {
  background: white;
  .list-item {
    display: flex;
    align-items: center;
    padding: 15px;
    background-color: white;
    border-bottom: #F1F3F6 1px solid;
    .content {
      box-sizing: border-box;
      width: 100%;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 1.5;

      text-overflow: ellipsis;
      overflow: hidden; /** 隐藏超出的内容 **/
      word-break: break-all;
      text-overflow: ellipsis; /** 多行 **/
      display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
      -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
      -webkit-line-clamp: 2; /** 显示的行数 **/
      margin-bottom: .3rem;
    }
  }

  .search-nav{
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .search-model {
    box-sizing: content-box;
    margin-top: 55px;
  }
  .search-page {
    padding-left: 15px;
    padding-right: 15px;
    min-height: calc(100vh - 56px);

    .search-title {
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      padding-right: 20px;
    }
    .history {
      display: flex;
      padding-top: 20px;
      padding-bottom: 20px;
      align-items: center;
    }

    .ico-trash {
      height: 18px;
      width: 18px;
    }

    .find {
      display: flex;
      padding-top: 20px;
      padding-bottom: 20px;
      align-items: center;
    }

    .ico-eyes {
      height: 17px;
      width: 18px;
    }
  }

  .no-data-page{
    height: calc(100vh - 56px);
    align-items: center;
  }


  ::v-deep .van-button {
    height: 30px;
    margin-right: 12px;
    margin-bottom: 10px;
    max-width: 300px;
  }

  ::v-deep .van-button__text {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; //文本不换行，这样超出一行的部分被截取，显示...
  }

  ::v-deep .custom-image .van-empty__image {
    width: 186px;
    height: 131px;
  }

  ::v-deep .van-empty__description {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
    line-height: 1.5;
  }
}
</style>